import algoliasearch from 'algoliasearch/lite';
import {createInMemoryCache} from '@algolia/cache-in-memory';
import {createBrowserLocalStorageCache} from '@algolia/cache-browser-local-storage';
import {createFallbackableCache} from '@algolia/cache-common';

const searchClient = algoliasearch(
  import.meta.env.PUBLIC_ALGOLIA_APP_API_KEY,
  import.meta.env.PUBLIC_ALGOLIA_ADMIN_API_KEY,
  {
    responsesCache: createFallbackableCache({
      caches: [
        createBrowserLocalStorageCache({
          key: `algolia-responses-${
            import.meta.env.PUBLIC_ALGOLIA_APP_API_KEY
          }-1`,
          timeToLive: 60 * 60 * 24, // TTL in seconds, e.g., 1 day
        }),
        createInMemoryCache(),
      ],
    }),
    requestsCache: createFallbackableCache({
      caches: [
        createBrowserLocalStorageCache({
          key: `algolia-requests-${
            import.meta.env.PUBLIC_ALGOLIA_APP_API_KEY
          }-1`,
          timeToLive: 60 * 60 * 24, // TTL in seconds, e.g., 1 day
        }),
        createInMemoryCache(),
      ],
    }),
  },
);

export default searchClient;
